export default __webpack_public_path__ + "static/media/AdobeStock_84143584.4ccd4bd1.jpg";